import { motion } from 'framer-motion';

export default function ResourcesSection() {
  const resources = [
    {
      icon: 'ri-file-pdf-line',
      title: '안전관리계획서 작성 가이드',
      description: '건설기술진흥법에 따른 안전관리계획서 작성 실무 가이드',
      date: '2024.01.15',
      size: '2.5MB',
      link: 'https://1drv.ms/b/c/c2395a9252671c9f/IQDhaPi4s0hoR52ndqw9-w7CAe72v9kFJ0OGpjnNQWPaBlc?e=sTjaup',
    },
    {
      icon: 'ri-file-pdf-line',
      title: '유해위험방지계획서 양식',
      description: '산업안전보건법 제42조에 따른 표준 양식 및 작성 예시',
      date: '2024.01.10',
      size: '1.8MB',
      link: 'https://1drv.ms/b/c/c2395a9252671c9f/IQBzB2aMM0YcR6ctzPmutXdHAXznD22EhGIHJV3CBqaT3vQ?e=KzOSAK',
    },
    {
      icon: 'ri-file-pdf-line',
      title: '중대재해처벌법 대응 매뉴얼',
      description: '중소건설회사를 위한 안전보건관리체계 구축 가이드',
      date: '2023.12.20',
      size: '3.2MB',
      link: 'https://1drv.ms/b/c/c2395a9252671c9f/IQAQrvTOv_stS4-L8q9Dc5brASrpSTW5fN-4O_fGTsmX80o?e=WnBDYN',
    },
    {
      icon: 'ri-file-pdf-line',
      title: '안전관리계획서/유해위험방지계획서 작성대상',
      description: '산업안전보건법 및 건설기술진흥법 주요 내용 정리',
      date: '2023.12.05',
      size: '4.1MB',
      link: 'https://1drv.ms/b/c/c2395a9252671c9f/IQAyRtG571QJTq7t2Bi9hJRqAdKqt8TcfSNtrDc3TrOolos?e=ZWKHdK',
    },
  ];

  const catalogs = [
    {
      icon: 'ri-book-2-line',
      title: '회사 홍보 카달로그',
      description: '주식회사 더불어안전 회사 소개 및 주요 서비스 안내',
      date: '2025.01.01',
      size: '5.8MB',
    },
  ];

  const csiGuides = [
    {
      icon: 'ri-shield-check-line',
      title: 'CSI 등록 신청 가이드',
      description: '건설안전정보시스템(CSI) 등록 절차 및 필수 서류 안내',
      date: '2024.02.01',
      size: '2.1MB',
      link: 'https://1drv.ms/b/c/c2395a9252671c9f/IQAevUD89tn3TqLK5uaN0nEVAYH6HDh81q3yhnDlCq_iS_o?e=lTZbAP',
    },
    {
      icon: 'ri-file-list-line',
      title: 'CSI 제출 서류 체크리스트',
      description: 'CSI 등록을 위한 필수 제출 서류 및 작성 요령',
      date: '2024.01.28',
      size: '1.5MB',
      link: 'https://1drv.ms/b/c/c2395a9252671c9f/IQBzB2aMM0YcR6ctzPmutXdHAXznD22EhGIHJV3CBqaT3vQ?e=KzOSAK',
    },
  ];

  return (
    <section id="resources" className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[#ff6b35] text-xs font-semibold tracking-[0.2em] mb-2 sm:mb-3">RESOURCES</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2b4a] mb-2">기타자료</h2>
          <div className="w-16 sm:w-20 h-1 bg-[#ff6b35] mb-8 sm:mb-12"></div>
        </motion.div>

        {/* Company Catalog Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-8 sm:mb-12"
        >
          <h3 className="text-xl sm:text-2xl font-bold text-[#1a2b4a] mb-4 sm:mb-6 flex items-center gap-2">
            <i className="ri-folder-line text-[#ff6b35]"></i>
            회사홍보 카달로그
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {catalogs.map((catalog, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gradient-to-br from-[#ff6b35]/5 to-[#ff6b35]/10 border border-[#ff6b35]/20 rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:from-[#ff6b35]/10 hover:to-[#ff6b35]/15 transition-all cursor-pointer group"
              >
                <div className="flex gap-3 sm:gap-5">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#ff6b35]/20 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#ff6b35]/30 transition-colors">
                    <i className={`${catalog.icon} text-[#ff6b35] text-2xl sm:text-3xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm sm:text-lg font-bold text-[#1a2b4a] mb-1 sm:mb-2 group-hover:text-[#ff6b35] transition-colors">
                      {catalog.title}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3 leading-relaxed">{catalog.description}</p>
                    <div className="flex items-center gap-3 sm:gap-4 text-[10px] sm:text-xs text-gray-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {catalog.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-file-line"></i>
                        {catalog.size}
                      </span>
                    </div>
                  </div>
                  <a 
                    href="https://1drv.ms/b/c/c2395a9252671c9f/IQC8PWl5suoRSrhTEuNpQTYKAStjS2g7IyrL-LlrQhkvWAA?e=dvwdW1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-lg flex items-center justify-center text-[#ff6b35] hover:bg-[#ff6b35] hover:text-white transition-all flex-shrink-0 self-center"
                  >
                    <i className="ri-download-line text-base sm:text-lg"></i>
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Resources Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-8 sm:mb-12"
        >
          <h3 className="text-xl sm:text-2xl font-bold text-[#1a2b4a] mb-4 sm:mb-6 flex items-center gap-2">
            <i className="ri-file-list-3-line text-[#ff6b35]"></i>
            참고자료
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {resources.map((resource, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-[#f8f9fa] rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:bg-[#f0f2f5] transition-all cursor-pointer group"
              >
                <div className="flex gap-3 sm:gap-5">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#ff6b35]/10 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#ff6b35]/20 transition-colors">
                    <i className={`${resource.icon} text-[#ff6b35] text-2xl sm:text-3xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm sm:text-lg font-bold text-[#1a2b4a] mb-1 sm:mb-2 group-hover:text-[#ff6b35] transition-colors">
                      {resource.title}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3 leading-relaxed">{resource.description}</p>
                    <div className="flex items-center gap-3 sm:gap-4 text-[10px] sm:text-xs text-gray-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {resource.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-file-line"></i>
                        {resource.size}
                      </span>
                    </div>
                  </div>
                  {resource.link ? (
                    <a 
                      href={resource.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-lg flex items-center justify-center text-[#ff6b35] hover:bg-[#ff6b35] hover:text-white transition-all flex-shrink-0 self-center"
                    >
                      <i className="ri-download-line text-base sm:text-lg"></i>
                    </a>
                  ) : (
                    <button className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-lg flex items-center justify-center text-[#ff6b35] hover:bg-[#ff6b35] hover:text-white transition-all flex-shrink-0 self-center">
                      <i className="ri-download-line text-base sm:text-lg"></i>
                    </button>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* CSI Registration Guide Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="text-lg sm:text-xl font-bold text-[#1a2b4a] mb-4 sm:mb-6 flex items-center gap-2">
            <i className="ri-shield-star-line text-[#ff6b35]"></i>
            CSI 등록 가이드
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {csiGuides.map((guide, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-[#f8f9fa] rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:bg-[#f0f2f5] transition-all cursor-pointer group"
              >
                <div className="flex gap-3 sm:gap-5">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#ff6b35]/10 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#ff6b35]/20 transition-colors">
                    <i className={`${guide.icon} text-[#ff6b35] text-2xl sm:text-3xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h5 className="text-sm sm:text-lg font-bold text-[#1a2b4a] mb-1 sm:mb-2 group-hover:text-[#ff6b35] transition-colors">
                      {guide.title}
                    </h5>
                    <p className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3 leading-relaxed">{guide.description}</p>
                    <div className="flex items-center gap-3 sm:gap-4 text-[10px] sm:text-xs text-gray-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {guide.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-file-line"></i>
                        {guide.size}
                      </span>
                    </div>
                  </div>
                  {guide.link ? (
                    <a 
                      href={guide.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-lg flex items-center justify-center text-[#ff6b35] hover:bg-[#ff6b35] hover:text-white transition-all flex-shrink-0 self-center"
                    >
                      <i className="ri-download-line text-base sm:text-lg"></i>
                    </a>
                  ) : (
                    <button className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-lg flex items-center justify-center text-[#ff6b35] hover:bg-[#ff6b35] hover:text-white transition-all flex-shrink-0 self-center">
                      <i className="ri-download-line text-base sm:text-lg"></i>
                    </button>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
